/**
 * Attachments arrive as bare URLs with no MIME type, so the element used to render them (`<img>` vs
 * `<video>`) has to be inferred from the URL itself. A video in an `<img>` renders as a broken image.
 */

const VIDEO_EXTENSIONS = /\.(mp4|webm|ogv|ogg|mov|m4v|3gp|avi|mkv)(\?|#|$)/i;
const IMAGE_EXTENSIONS = /\.(jpe?g|png|gif|webp|bmp|svg|avif|heic|heif)(\?|#|$)/i;

export function isVideoAttachment(url: string | null | undefined): boolean {
  if (!url) return false;
  // Locally picked files are read as data URLs, which carry the MIME type outright.
  if (url.startsWith('data:')) return url.startsWith('data:video/');
  // Cloudinary can serve a still poster out of a `/video/upload/` path, so an image extension wins.
  if (IMAGE_EXTENSIONS.test(url)) return false;
  return VIDEO_EXTENSIONS.test(url) || url.includes('/video/upload/');
}
